module.exports = __webpack_public_path__ + "static/assets/0cbed2a31cdacb8e1a40f48261c6acc6.png";